
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { CENTER_ZOOM, BREAKPOINT } from '../../constants/map';
import * as actionCreators from '../../actions/actionCreators';
import MapListItem from '../MapListItem/MapListItem';
import mediaCheck from '../../utils/mediaCheck';

const isMobile = () => !mediaCheck(`min-width: ${BREAKPOINT}px`);

class MapList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            listLength: 0
        };
        this.scrollContainer = React.createRef();
    }

    loadMore = e => {
        if (
            e.target.scrollHeight - e.target.scrollTop ===
            e.target.clientHeight
        ) {
            if (this.state.listLength < this.props.listMarkers.length) {
                this.setState(prevState => ({
                    listLength: Math.min(
                        prevState.listLength + 50,
                        this.props.listMarkers.length
                    )
                }));
            }
        }
    };

    componentDidMount() {
        this.state = {
            listLength: Math.min(this.props.listMarkers.length, 50)
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.listMarkers.length !== this.props.listMarkers.length) {
            this.setState({
                listLength: Math.min(this.props.listMarkers.length, 50)
            });
            this.scrollContainer.current.scrollTop = 0;
        }
        if (prevProps.listActive !== this.props.listActive) {
            setTimeout(() => {
                this.scrollContainer.current.scrollTop = 0;
            }, 500);
        }
    }

    handleItemClick = marker => {
        const center = {
            lat: marker.point.coordinates[1],
            lng: marker.point.coordinates[0]
        };
        const zoom = Math.max(CENTER_ZOOM, this.props.zoom);

        this.props.setCenter(center);
        this.props.setZoom(zoom);
        this.props.setListMarkers([]);
        this.props.setSearchvalue('');
        this.props.setListActive(false);

        if (!isMobile()) {
            this.props.onMarkerClick(marker);
        }
    };

    render() {
        const {
            listActive,
            labels,
            services,
            listMarkers,
            language,
        } = this.props;

        const { listLength } = this.state;
        const classes = classNames('MapList', {
            [`MapList--Active`]: listActive
        });

        return (
            <div className={classes}>
                <div className="MapList__Container">
                    <div
                        className="MapList__Content"
                        ref={this.scrollContainer}
                        onScroll={this.loadMore}
                    >
                        {listMarkers.length > 0 ? (
                            <ul className="MapList__List">
                                {listMarkers
                                    .slice(0, listLength)
                                    .map((item, index) => (
                                        <MapListItem
                                            labels={labels}
                                            services={services}
                                            item={item}
                                            key={index}
                                            language={language}
                                            onClick={this.handleItemClick}
                                        />
                                    ))}
                            </ul>
                        ) : (
                            <span className="MapList__NoResult">Din sökning gav inget resultat</span>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

MapList.defaultProps = {
    listMarkers: []
};

function mapStateToProps(state) {
    return {
        listMarkers: state.map.listMarkers,
        zoom: state.map.zoom,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MapList);
